import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import { Login, Register, ForgotPassword } from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import { Queue, MyTasks, Done } from "./pages/Queues";
import AllTasks from "./pages/AllTasks";
import Processes from "./pages/Processes";
import Users from "./pages/Users";
import TaskDetail from "./pages/TaskDetail";
import Roles from "./pages/Roles";
import Workload from "./pages/Workload";
import PasswordRequests from "./pages/PasswordRequests";
import { RolesProvider } from "./context/RolesContext";
import { isManager } from "./lib/api";

const Protected = ({ admin, manager, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#0B0D12] text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" />;
  if (admin && !user.is_admin) return <Navigate to="/" />;
  if (manager && !isManager(user)) return <Navigate to="/" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <RolesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="queue" element={<Queue />} />
            <Route path="my-tasks" element={<MyTasks />} />
            <Route path="done" element={<Done />} />
            <Route path="tasks" element={<Protected manager><AllTasks /></Protected>} />
            <Route path="tasks/:id" element={<TaskDetail />} />
            <Route path="processes" element={<Protected manager><Processes /></Protected>} />
            <Route path="users" element={<Protected admin><Users /></Protected>} />
            <Route path="roles" element={<Protected admin><Roles /></Protected>} />
            <Route path="workload" element={<Protected manager><Workload /></Protected>} />
            <Route path="password-requests" element={<Protected manager><PasswordRequests /></Protected>} />
          </Route>
        </Routes>
      </BrowserRouter>
      </RolesProvider>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1C202E", border: "1px solid #282E3D", color: "#F8FAFC" } }} />
    </AuthProvider>
  );
}

export default App;
